import { render, staticRenderFns } from "./PurchaseEdit.vue?vue&type=template&id=97b06790&scoped=true"
import script from "./PurchaseEdit.vue?vue&type=script&lang=ts"
export * from "./PurchaseEdit.vue?vue&type=script&lang=ts"
import style0 from "./PurchaseEdit.vue?vue&type=style&index=0&id=97b06790&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97b06790",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('97b06790')) {
      api.createRecord('97b06790', component.options)
    } else {
      api.reload('97b06790', component.options)
    }
    module.hot.accept("./PurchaseEdit.vue?vue&type=template&id=97b06790&scoped=true", function () {
      api.rerender('97b06790', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/purchases/PurchaseEdit.vue"
export default component.exports